import Lottie from "lottie-react";
import loadingAnimation from "../btck-loading.json";
import "../styles/LoadingSpinner.css";

function LoadingSpinner({ message = "Carregando..." }) {
  return (
    <div className="loading-container">
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        className="loading-animation"
      />
      <p className="loading-message">{message}</p>
    </div>
  );
}

export default LoadingSpinner;
